import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import createSagaMiddleWare from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import Config from './DebugConfig'
import rootSaga from '../store/sagas'
import reducers from '../store/reducers'

import { SAVE_IMAGE_DATA } from '../store/types/image.types'
import {
  ADD_SETTING,
  SETTING_ADDED,
  UPDATE_LAST_SETTING
} from '../store/types/settings.types'

const configureStore = () => {
  /* ------------ Redux Configuration ------------ */
  const sagaMiddleware = createSagaMiddleWare()
  const middleware = [sagaMiddleware]
  const enhancers = []

  /* ------------ Saga Middleware ------------ */

  let composeEnhancers = compose
  if (Config.reduxLogging && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    const imageDataStub = '<<IMAGE_DATA>>'

    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      maxAge: 20,
      actionSanitizer: (action) => {
        switch (action.type) {
          case SAVE_IMAGE_DATA:
            return {...action, payload: imageDataStub}
          case ADD_SETTING:
          case SETTING_ADDED:
          case UPDATE_LAST_SETTING:
            return {...action, payload: {...action.payload, imageData: imageDataStub}}
          default:
            return action
        }
      },
      stateSanitizer: (state) => {
        let sanitizedState = {...state}

        if (sanitizedState.settingsStore.settingsList.length) {
          const sanitizedList = sanitizedState.settingsStore.settingsList.map((setting) => (
            setting.imageData ? {...setting, imageData: imageDataStub} : setting
          ))

          sanitizedState = {...sanitizedState, settingsStore: { ...sanitizedState.settingsStore, settingsList: sanitizedList }}
        }

        if (sanitizedState.imageStore.imageData) {
          sanitizedState = { ...sanitizedState, imageStore: { ...sanitizedState.imageStore, imageData: imageDataStub }}
        }

        return sanitizedState
      }
    })
  }

  enhancers.push(applyMiddleware(...middleware))

  /* ------------ Redux Persist @ Local Storage ------------ */

  const imageStorePersistConfig = {
    key: 'imageStore',
    storage: storage,
    whitelist: ['imageFormat', 'imageName', 'imageSize', 'imageSrcUploaded', 'imageType'],
  }

  const settingsStorePersistConfig = {
    key: 'settingsStore',
    storage,
    whitelist: ['shouldConfirmRevert'],
  }

  const rootReducer = combineReducers({
    ...reducers,
    settingsStore: persistReducer(settingsStorePersistConfig, reducers.settingsStore),
    imageStore: persistReducer(imageStorePersistConfig, reducers.imageStore),
  })

  /* ------------ Create Store and Persistor ------------ */

  const store = createStore(rootReducer, composeEnhancers(...enhancers))
  const persistor = persistStore(store)

  // This is where we will run the ol' Sagas
  sagaMiddleware.run(rootSaga)

  return { store, persistor }
}

// It will be:
export default configureStore
